"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchProductOrderControl = batchProductOrderControl;
exports.deleteProduct = deleteProduct;
exports.getProductInfo = getProductInfo;
exports.getProductList = getProductList;
exports.getUserClosePositionList = getUserClosePositionList;
exports.getUserProductOrderDetail = getUserProductOrderDetail;
exports.getUserProductOrderList = getUserProductOrderList;
exports.initProductData = initProductData;
exports.login = login;
exports.saveBatchProduct = saveBatchProduct;
exports.saveProduct = saveProduct;
exports.updateUserProductOrder = updateUserProductOrder;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function login(data) {
  return (0, _request.default)({
    url: '/admin/login',
    method: 'post',
    data: data
  });
}

// 获取产品列表
function getProductList(params) {
  return (0, _request.default)({
    url: '/admin/productManage/product/getProductList',
    method: 'get',
    params: params
  });
}

// 删除产品
function deleteProduct(data) {
  return (0, _request.default)({
    url: '/admin/productManage/product/deleteProduct',
    method: 'post',
    data: data
  });
}

// 获取产品详情
function getProductInfo(params) {
  return (0, _request.default)({
    url: '/admin/productManage/product/getProductInfo',
    method: 'get',
    params: params
  });
}

// 保存产品
function saveProduct(data) {
  return (0, _request.default)({
    url: '/admin/productManage/product/saveProduct',
    method: 'post',
    data: data
  });
}

// 批量编辑
function saveBatchProduct(data) {
  return (0, _request.default)({
    url: '/admin/productManage/product/batchUpdateProduct',
    method: 'post',
    data: data
  });
}

// 获取产品订单
function getUserProductOrderList(params) {
  return (0, _request.default)({
    url: '/admin/productManage/productOrder/getUserProductOrderList',
    method: 'get',
    params: params
  });
}

// 获取产品订单详情 
function getUserProductOrderDetail(params) {
  return (0, _request.default)({
    url: '/admin/productManage/productOrder/getUserProductOrderDetail',
    method: 'get',
    params: params
  });
}

// 获取平仓日志列表
function getUserClosePositionList(params) {
  return (0, _request.default)({
    url: '/admin/productManage/productOrder/getUserClosePositionList',
    method: 'get',
    params: params
  });
}

// 批量控制订单盈亏
function batchProductOrderControl(params) {
  return (0, _request.default)({
    url: '/admin/productManage/productOrder/batchProductOrderControl',
    method: 'post',
    data: params
  });
}

// 修改产品交易
function updateUserProductOrder(data) {
  return (0, _request.default)({
    url: "/admin/productManage/productOrder/updateUserProductOrder",
    method: 'post',
    data: data
  });
}

// 初始化产品
function initProductData(data) {
  return (0, _request.default)({
    url: "/admin/product/initProductData",
    method: 'post',
    data: data
  });
}